<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import vue2Dropzone from 'vue2-dropzone'
import axios from 'axios'
import { axiosGetPost } from '@router/axiosGetPost'
import WaitingStatus from '@/src/components/WaitingStatus'
import moment from 'moment'

export default {
  page: {
    title: 'Importation Transit Times',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, Multiselect, vueDropzone: vue2Dropzone, WaitingStatus },
  props: {
    user: {
      type: [Array, Object],
      default: function () {
        return {}
      },
    },
  },
  data() {
    return {
      title: 'Importation Transit Times',
      items: [
        {
          text: 'Barracuda',
          href: '/',
        },
        {
          text: 'Transit Times',
          href: '/transittimes',
        },
        {
          text: 'Import',
          active: true,
        },
      ],
      errors: [],
      loandingData: false,
      waitingStatusC: false,
      seletedOptions: {
        fileName: null,
        dropzoneOptions: {
          url: process.env.VUE_APP_RUTA_API + 'cargofive/upload_file',
          thumbnailWidth: 150,
          maxFilesize: 10.0,
          dictDefaultMessage:
            "<i class='uil uil-cloud-upload'></i> Upload File",
          maxFiles: 1,
          addRemoveLinks: true,
          headers: {
            Authorization: this.user.token,
          },
        },
      },
      accountTTId: null,
      message: null,
      messageBool: false,
    }
  },
  created() {
  },
  methods: {

    redirectGoodAndFail(){
      this.$router.push({ path: `/transittimes` })
    },
    saveData() {
      // replace `getPost` with your data fetching util / API wrapper
      this.loandingData = true
      this.messageBool = false
      this.message = null
      axiosGetPost('post', '/transit_times/import_file', {
        selectedOptions: this.seletedOptions
      }).then((data) => {
         console.log(data)
        if(data.success === true){
          this.waitingStatusC = true
          this.accountTTId = data.account_id
          this.$toastr.s('Successful. In process.')
        } else {
          this.loandingData = false
          this.messageBool = true
          this.message = data.messages+ '. Error File.'
          this.$toastr.e(data.messages+ '. Error File.')
        }
        return data
      })
    },
    removeFile() {
      const dataDic = {
        filename: this.seletedOptions.fileName,
      }
      axiosGetPost('post', '/cargofive/delete_file', dataDic).then(
        (response) => {
          let data = response.data
          if (data.success === true) {
            this.seletedOptions.fileName = null
          } else {
            this.seletedOptions.fileName = null
            this.$toastr.e('Error Delete in Server. Error: ' + data.error)
          }
          return data
        }
      )
    },
    vsuccess(file, response) {
      this.seletedOptions.fileName = response.file_name
    },
    validateForm() {
      let formAction = false
      let message = ''
      this.errors = []
      if (!this.seletedOptions.fileName) {
        this.errors.push('The File is required.')
      }

      if (this.errors.length > 0) {
        formAction = true
        // Send message to browser screen
        this.errors.forEach((element) => {
          message += '<li> ' + element + ' </li>'
        })
        this.$toastr.e("Error : <ul color='yellow'>" + message + '</ul>')
      }

      if (formAction === false) {
        this.saveData()
        // alert('se ejecuta saveData()')
      }
    },
    test() {
      console.log(this.seletedOptions)
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <form action>
            <div class="card-body">
              <h4 class="header-title mb-3 mt-0">Importation - File</h4>
                  <h4 v-if="messageBool" style="color:brown"> {{message}}</h4>
              <div v-if="loandingData === false">

                <div class="form-group">
                  <div class="row">
                    <div class="col-xl-12 col-sm-12">
                      <div class="form-group mt-1 mt-sm-0">
                        <vue-dropzone id="dropzone" ref="myVueDropzone" :options="seletedOptions.dropzoneOptions"
                          :destroyDropzone="false" @vdropzone-removed-file="removeFile" @vdropzone-success="vsuccess">
                          <div class="text-center">
                            <i class="h1 text-muted uil-cloud-upload"></i>
                            <h3>Drop files here or click to upload.</h3>
                            <span class="text-muted font-size-13">
                              (This is just a demo dropzone. Selected files are
                              <strong>not</strong> actually uploaded.)
                            </span>
                          </div>
                        </vue-dropzone>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-5 col-sm-5"></div>
                    <div class="col-xl-2 col-sm-2">
                      <div class="form-group mt-1 mt-sm-0">
                        <button type="button" name="save" class="btn btn-primary form-control"
                          @click.prevent="validateForm">Save</button>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div v-else-if="loandingData === true && waitingStatusC === true">
                <WaitingStatus :request-id="accountTTId" :reload-time="15" @postevent="redirectGoodAndFail" 
                has-post-event url="/transit_times/getStatusTask/" />
              </div>
              <div v-else-if="loandingData === true && waitingStatusC === false" class="row align-items-center justify-content-center" style="height: 300px">
                <div class="col-12 col-md-8 text-center">
                  <b-spinner label="Loading..." variant="primary" class="ml-3"></b-spinner>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.vue-dropzone>.dz-preview .dz-remove {
  margin-left: 13px;
  padding: 33px;
  bottom: 55px;
}

.DRY {
  color: blue
}
</style>